import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";

const CountersFilter = ({ sort, reverse, update, count }) => {
  return (
    <>
      <FormControl style={{ maxWidth: "30%" }} fullWidth>
        <InputLabel id="select-order-label">انتخاب فیلتر</InputLabel>
        <Select
          labelId="select-order-label"
          id="select-order"
          value={sort.value}
          label="انتخاب فیلتر"
          onChange={(e) => sort.handleChange(e.target.value)}
          style={{ paddingLeft: "8px", paddingRight: "8px" }}
        >
          <MenuItem value={"consumption_create_time"}>
            <em>تاریخ آخرین ثبت مصرف</em>
          </MenuItem>
          <MenuItem value={"last_consumption"}>
            <em>آخرین میزان مصرف</em>
          </MenuItem>
          <MenuItem value={"month"}>
            <em>میزان مصرف ماه جاری</em>
          </MenuItem>
          <MenuItem value={"year"}>
            <em>کل میزان مصرف</em>
          </MenuItem>
        </Select>
      </FormControl>
      <FormControl style={{ maxWidth: "20%" }} fullWidth>
        <InputLabel id="reverse-label">ترتیب نمایش</InputLabel>
        <Select
          labelId="reverse-label"
          id="select-reverse"
          value={reverse.value}
          label="انتخاب ترتیب نمایش"
          onChange={(e) => reverse.handleChange(e.target.value)}
          style={{ paddingLeft: "8px", paddingRight: "8px" }}
        >
          <MenuItem value={true}>
            <em>نزولی</em>
          </MenuItem>
          <MenuItem value={false}>
            <em>صعودی</em>
          </MenuItem>
        </Select>
      </FormControl>
      <FormControl style={{ maxWidth: "20%" }} fullWidth>
        <InputLabel id="count-label">تعداد نمایش</InputLabel>
        <Select
          labelId="count-label"
          id="select-count"
          value={count.value}
          label="تعداد نمایش"
          onChange={(e) => count.handleChange(e.target.value)}
          style={{ paddingLeft: "8px", paddingRight: "8px" }}
        >
          {/* <MenuItem value={10}>
              <em>10</em>
            </MenuItem> */}
          <MenuItem value={20}>
            <em>20</em>
          </MenuItem>
          {/* <MenuItem value={30}>
              <em>30</em>
            </MenuItem> */}
          <MenuItem value={50}>
            <em>50</em>
          </MenuItem>
        </Select>
      </FormControl>
      <Button variant="contained" color="primary" onClick={() => update()}>
        اعمال فیلتر
      </Button>
    </>
  );
};
export default CountersFilter;
